
import {Component, Prop, Vue} from "vue-property-decorator";
import IComptage from "@/types/comptage.interface";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {TooltipDialog},
})
export default class ActivityFilterComptage extends Vue {

    @Prop() readonly filters!: { naf: [] };
    @Prop() readonly product: IComptage;
    @Prop() readonly loadingFilter: boolean;

    search = '';
    open = [];
    items = [];
    allOpened = false;
    lastOpen = [];
    loading = false;

    handleSearch(val) {
        if (val) {
            this.loading = true;
            if (!this.allOpened) {
                this.lastOpen = this.open;
                this.allOpened = true;
                this.open = this.filters.naf.concat(...JSON.parse(JSON.stringify(this.filters.naf)).map(a => a.children));
            }
            setTimeout(() => this.loading = false, 2000);
        } else {
            this.allOpened = false;
            this.open = this.lastOpen;
        }
    }

    customFilter(item, search, textKey) {
        const finalValue = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        const finalDescription = item.description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        const finalCode = item.code.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return finalDescription.includes(finalValue) || finalCode.includes(finalValue);
    }

}

